
import { getFallbackDealersData } from "./fallbacks";

/**
 * Fetches data from separate views: vw_dealers_with_ratings and vw_active_quotations
 * Optimization: Using available views and combining the data
 */
export const fetchDataFromSources = async (
  selectedMetal: string,
  signal?: AbortSignal
): Promise<{
  dealersData: any[]
}> => {
  try {
    console.log('Fetching dealer data from vw_dealers_with_ratings and vw_active_quotations');
    
    // Import the service that fetches and combines data from the separate views
    const { fetchDealersWithQuotations } = await import('../services/dealerService');
    
    // Fetch data from the views and combine them
    const dealersData = await fetchDealersWithQuotations(selectedMetal, signal);
    
    // Check if we have valid dealer data
    if (!dealersData || !Array.isArray(dealersData) || dealersData.length === 0) {
      console.log("No dealers found from primary source");
      
      // Return fallback data (which now only comes from localStorage cache)
      return {
        dealersData: getFallbackDealersData(selectedMetal)
      };
    }
    
    console.log(`Fetched ${dealersData.length} dealers with ratings and quotations for ${selectedMetal}`);
    
    return {
      dealersData
    };
  } catch (error) {
    console.error("Error fetching dealer source data:", error);
    
    // Return fallback data from localStorage only
    return {
      dealersData: getFallbackDealersData(selectedMetal)
    };
  }
};
